import { combineReducers } from 'redux';

import {
    REQUEST_KYC_INITIALIZE,
    SUCCESS_KYC_INITIALIZE,
    FAILURE_KYC_INITIALIZE,
    REQUEST_KYC_STATE,
    SUCCESS_KYC_STATE,
    FAILURE_KYC_STATE,
    RESET_KYC_STATE
} from './constants';

const widgetLink = (state = null, action) => {
    switch (action.type) {
        case SUCCESS_KYC_INITIALIZE:
            return action.response.payload.widgetLink;
        case REQUEST_KYC_INITIALIZE:
        case FAILURE_KYC_INITIALIZE:
        case RESET_KYC_STATE:
            return null;
        default:
            return state;
    }
};

const fetchingLink = (state = false, action) => {
    switch (action.type) {
        case REQUEST_KYC_INITIALIZE:
            return true;
        case FAILURE_KYC_INITIALIZE:
        case SUCCESS_KYC_INITIALIZE:
        case RESET_KYC_STATE:
            return false;
        default:
            return state;
    }
};

const errorLink = (state = '', action) => {
    switch (action.type) {
        case FAILURE_KYC_INITIALIZE:
            return action.response.message;
        case REQUEST_KYC_INITIALIZE:
        case SUCCESS_KYC_INITIALIZE:
        case RESET_KYC_STATE:
            return '';
        default:
            return state;
    }
};

const state = (state = null, action) => {
    switch (action.type) {
        case SUCCESS_KYC_STATE:
            return action.response.payload.state;
        case REQUEST_KYC_STATE:
        case FAILURE_KYC_STATE:
        case RESET_KYC_STATE:
            return null;
        default:
            return state;
    }
};

const fetchingState = (state = false, action) => {
    switch (action.type) {
        case REQUEST_KYC_STATE:
            return true;
        case FAILURE_KYC_STATE:
        case SUCCESS_KYC_STATE:
        case RESET_KYC_STATE:
            return false;
        default:
            return state;
    }
};

const errorState = (state = '', action) => {
    switch (action.type) {
        case FAILURE_KYC_STATE:
            return action.response.message;
        case REQUEST_KYC_STATE:
        case SUCCESS_KYC_STATE:
        case RESET_KYC_STATE:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    widgetLink,
    fetchingLink,
    errorLink,
    state,
    fetchingState,
    errorState
});



// WEBPACK FOOTER //
// ./src/services/kyc/reducer.js